export const LABOUR_CATALOG_GRID_CODE = 'labour-catalog-ds';
